import script from "./ContestSubmitImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestSubmitImage.vue?vue&type=script&setup=true&lang=js"

import "./ContestSubmitImage.vue?vue&type=style&index=0&id=7add1ce0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7add1ce0"]])

export default __exports__